// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import './style/index.css'
import App from './App'

import axios from './utils/request'

Vue.use(ElementUI)
Vue.prototype.$axios = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// 解决跳转到详情页，滚动条不在顶部问题
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/main.js